"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/fp/isEqual"));

var _Collapse = _interopRequireDefault(require("../collapse/Collapse"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ExpanderList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ExpanderList, _Component);

  var _super = _createSuper(ExpanderList);

  /* istanbul ignore next */
  function ExpanderList() {
    var _this;

    (0, _classCallCheck2.default)(this, ExpanderList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      items: _this.parseItems(_this.props.items)
    };
    return _this;
  }

  (0, _createClass2.default)(ExpanderList, [{
    key: "parseItems",
    value: function parseItems(items) {
      return items.map(function (item, index) {
        // Generate a unique id (if not present) instead of using the index for the key as it will create
        // side effects when removing items from the list and re-render the ExpanderList.
        if (!item.id) {
          item.id = "".concat(index, "-").concat(Math.random());
        }

        return item;
      });
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Map the internal open state to the new props in order to preserve opened items
      var mappedNextProps = nextProps.items.map(function (item) {
        if (item.open === undefined || item.open === null) {
          var matchingItem = _this2.state.items.find(function (oldItem) {
            return oldItem.id === item.id;
          });

          if (matchingItem) {
            item.open = matchingItem.open;
          }
        }

        return item;
      }); // Only update the list when the amount of items is different or items inside have changed.
      // Note: When using the generated internal "id" the check is always true, as the id is regenerated for new
      // items, means it will always update the state and hence re-render.

      if (!(0, _isEqual.default)(mappedNextProps, this.state.items)) {
        this.setState({
          items: this.parseItems(mappedNextProps)
        });
      }
    }
  }, {
    key: "handleExpand",
    value: function handleExpand(itemToExpand) {
      // Toggle the open state for the selected item based on the provided or generated id
      var result = this.state.items.find(function (item) {
        return item.id === itemToExpand.id;
      });
      result.open = !result.open;
      this.setState({
        items: this.state.items
      });
    }
  }, {
    key: "getHeaderElement",
    value: function getHeaderElement(item) {
      var _this3 = this;

      var headerClassNames = (0, _classnames.default)('expander-list-header', item.headerClassName && item.headerClassName);
      var iconClassNames = item.body && (0, _classnames.default)('expander-icon', 'rioglyph', 'rioglyph-chevron-down');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: headerClassNames,
        onClick: function onClick() {
          if (item.body) {
            _this3.handleExpand(item);
          }
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "expander-list-header-content"
      }, item.header), /*#__PURE__*/_react.default.createElement("span", {
        className: iconClassNames
      }));
    }
  }, {
    key: "getBodyElement",
    value: function getBodyElement(item, isOpen, mountOnEnter, unmountOnExit) {
      if (!item.body) {
        return;
      }

      var bodyClassNames = (0, _classnames.default)('expander-list-body', item.bodyClassName && item.bodyClassName);
      return /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        in: isOpen,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "expander-list-body-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: bodyClassNames
      }, item.body)));
    }
  }, {
    key: "getListItem",
    value: function getListItem(item) {
      var isOpen = item.open;
      var itemClassNames = (0, _classnames.default)('list-group-item', item.className && "".concat(item.className), item.body && 'expandable', isOpen && 'open');
      return /*#__PURE__*/_react.default.createElement("li", {
        className: itemClassNames,
        key: item.id
      }, this.getHeaderElement(item), this.getBodyElement(item, isOpen, this.props.mountOnEnter, this.props.unmountOnExit));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var listClassNames = (0, _classnames.default)('expander-list list-group', this.props.className);
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: listClassNames
      }, this.state.items.map(function (item) {
        return _this4.getListItem(item);
      }));
    }
  }]);
  return ExpanderList;
}(_react.Component);

exports.default = ExpanderList;
ExpanderList.defaultProps = {
  items: [],
  mountOnEnter: true,
  unmountOnExit: true
};
ExpanderList.propTypes = {
  className: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    body: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    open: _propTypes.default.bool,
    className: _propTypes.default.string,
    headerClassName: _propTypes.default.string,
    bodyClassName: _propTypes.default.string
  })).isRequired,
  mountOnEnter: _propTypes.default.bool,
  unmountOnExit: _propTypes.default.bool
};